<!-- @format -->

<section class="homr-wire-spot-content hmf-position-relative hmf-mb-m hmf-mb-m-xl">
  @if (enhancedProductCardContent$ | async; as slides) {
    <ng-container>
      <hmf-carousel
        [showHeader]="false"
        [showTitle]="false"
        [showSubtitle]="false"
        [showActionButton]="false">
        @for (slide of slides; track trackBySlide($index, slide)) {
          <article
            class="homr-wire-spot-card hmf-display-flex hmf-mr-xxs hmf-mr-m-s">
            <div
              class="homr-wire-spot-left-column hmf-flex-column hmf-justify-content-center hmf-px-s hmf-px-m-xl hmf-mr-xxs hmf-mr-m-s">
              @if (slide.logo && slide.logo === 'calia') {
                <img
                  class="homr-wire-spot-logo hmf-display-flex hmf-mb-s"
                  src="assets/image/calia-logo.svg"
                  alt="Calia logo"
                  [attr.loading]="lazyLoadImages() ? 'lazy' : 'eager'" />
              }
              @if (slide.title) {
                <p
                  class="homr-wire-spot-title hmf-mb-xxs hmf-header-bold-l">
                  {{ slide.title }}
                </p>
              }
              <div
                [innerHTML]="decodeURIPipe.transform(slide.wysiwyg)"
              class="homr-wire-spot-text"></div>
            </div>
            @if (slide.visualAssets && slide.visualAssets.length) {
              <div
                class="homr-wire-spot-image">
                <img
                  #img
                  [alt]="slide.visualAssets[0]['0'].altText"
                  [attr.loading]="lazyLoadImages() ? 'lazy' : 'eager'"
                  [src]="slide.visualAssets[0]['0'].value"
                  (error)="utilityService.setFallbackImage($event, fallbackImage)" />
              </div>
            }
          </article>
        }
      </hmf-carousel>
    </ng-container>
  }
</section>
